import { gql } from '@apollo/client'

export const UPDATE_AI_RECOMMENDATION_PROMPT = gql`
  mutation UpdateAiRecommendationPrompt($content: String!) {
    updateAiRecommendationPrompt(input: { content: $content }) {
      aiRecommendationPrompt {
        id
        content
        updatedAt
      }
      errors
    }
  }
`
